import React from "react"

export const Loader: React.FC = () => {
    return (
        <>
            <div className="spinner">
                <div className="simple-spinner"></div>
            </div>
        </>
    )
}